import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { api, errMsg } from "../lib/api";

export default function SetupPage({ onDone }) {
  const [code, setCode] = useState("");
  const nav = useNavigate();
  const submit = async () => {
    try { await api.post("/setup", { code }); toast.success("Owner account created"); await onDone(); nav("/"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="panel p-8 max-w-md w-full space-y-4" data-testid="setup-page">
        <h1 className="text-2xl font-black">Owner initial setup</h1>
        <p className="text-sm text-zinc-600">One-time setup. You must be signed in with the designated owner email and enter the setup code. This page locks permanently once the owner account exists.</p>
        <input className="fld w-full mono" placeholder="Setup code" value={code} onChange={(e) => setCode(e.target.value)} data-testid="setup-code-input" />
        <Button className="w-full" onClick={submit} data-testid="setup-submit-btn">Create owner admin account</Button>
      </div>
    </div>
  );
}
